<template>
  <div>
    <template v-if="template === 'edit' || typeof template === 'undefined'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
      <select
        @change   = "update($event.target.value)"
        :class    = "'o-select qa-' + field.name + '__input'"
        :value    = "value"
        :disabled = "field.readonly"
        :readonly = "field.readonly"
      >
        <option v-if="!field.hasNoEmptyOption" value="">--</option>
        <option
          v-for     = "item in field.options"
          :value    = "item.value"
          :selected = "item.value == value ? 'selected' : ''"
        >
          {{ item.label }}
        </option>
      </select>
    </template>
    <template v-if="template === 'detail'">
      <label :class="labelClass ? labelClass : 'u-label'">
        {{ field.label + (field.required ? '* ' : '') }}
      </label>
        <p
          class  = "u-paragraph"
          :class = "'qa-' + field.name + '__value'"
        >
          {{ displayValue }}
        </p>
    </template>
  </div>
</template>


<script>
import util from '@/functions'

export default {
  props: ['field', 'value', 'labelClass', 'template'],
  computed: {
    displayValue () {
      return util.getDropdownLabel(this.value, this.field.options)
    }
  },
  methods: {
    update (value) {
      this.$emit('input', value)
    }
  }
}
</script>



// WEBPACK FOOTER //
// FieldEnum.vue?4a33cbbb